export const SET_ALERT = "SET_ALERT";
export const CLEAR_ALERT = "CLEAR_ALERT";
export const SET_LOADING = "SET_LOADING";
export const CLEAR_LOADING = "CLEAR_LOADING";
export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";
export const SET_MODE = "SET_MODE";
export const SET_BANNER = "SET_BANNER";
export const CLEAR_BANNER = "CLEAR_BANNER";
